import { forwardRef, useContext, useState } from "react"
import { Mousewheel, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useRouter } from "next/router";
import BuildingTypeCard from "./BuildingTypeCard";
import Magnitizer from "../Animations/Magnitizer";
import FadeIn from "../Animations/FadeIn";

// eslint-disable-next-line react/display-name
const BuildingType = forwardRef(({ PojectBuilding, title, businessProject }, ref) => {
	const { locale } = useRouter();
	const [slideNumber, setSlideNumber] = useState(1)
	return (
		<div className={`building-type-section`} ref={ref}>
			<FadeIn customClass="header">
				<h2 className="light _eleX">{title}</h2>
			</FadeIn>
			<FadeIn customClass="building-swiper">
				<Swiper
					style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
					modules={[Navigation, Pagination, Mousewheel]}
					navigation={{
						nextEl: ".swiper-button-next-building",
						prevEl: ".swiper-button-prev-building",
					}}
					pagination={{
						type: "progressbar",
						el: ".swiper-building-navigation",
					}}
					
					onSlideChange={(swiper) => { setSlideNumber((swiper.realIndex + 1)) }}
					slidesPerView={1}
					spaceBetween={25}
					breakpoints={{
						768: {
							slidesPerView: 1.5,
							spaceBetween: 20,
						},
						1024: {
							slidesPerView: businessProject ? 1.35 : 1.15,
							spaceBetween: 40,
						},
					}}
					speed={500}
				// loop={true}
				>
					{PojectBuilding?.map((card, index) => (
						<SwiperSlide key={index} className="_eleX">
							<BuildingTypeCard
								title={card?.Building_Title}
								cardData={card}
								Button_Text1={card?.Button_Text1}
								Button_Text2={card?.Button_Text2}
								description={card?.Description}
								businessProject={businessProject}
							/>
						</SwiperSlide>
					))}
				</Swiper>
			</FadeIn>
			<div className={`swiper-navigation-continer ${PojectBuilding?.length == 1 ? "d-none" : ""}`}>
				<div className="navigation-container">
					<div className="slide-number-container bold">
						<div>{slideNumber.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>
						<div>{PojectBuilding?.length.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>
					</div>
					<div className="swiper-building-navigation swiper-pagination-progressbar"
					></div>
				</div>
				<div className="arrows-container">
					<Magnitizer dataDest={1.5}>
						<div className="swiper-button-prev swiper-button-prev-building building-arrow black-arrow-prev"
						></div>
					</Magnitizer>
					<Magnitizer dataDest={1.5}>
						<div className="swiper-button-next swiper-button-next-building  building-arrow black-arrow-next"
						></div>
					</Magnitizer>
				</div>
			</div>
		</div>
	)
})

export default BuildingType
